import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-403279a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-container" }
const _hoisted_2 = { class: "carouse-container" }
const _hoisted_3 = { id: "carouse" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = {
  id: "main",
  ref: "chartDom"
}
const _hoisted_6 = {
  class: "select",
  ref: "buttons"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "description" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Explore QuanDB", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Description: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Introduction: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button-31",
  role: "button"
}, "Browse all data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoaderView = _resolveComponent("LoaderView")!
  const _component_MaskView = _resolveComponent("MaskView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "left",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.prevPlot && $setup.prevPlot(...args)), ["prevent"]))
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, null, 512),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.totalPlot, (i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass({active: (i === 1)})
                }, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => ($setup.select($event, i)), ["prevent"])
                  }, _toDisplayString(i), 9, _hoisted_7)
                ], 2))
              }), 128))
            ], 512)
          ]),
          _createElementVNode("div", {
            class: "right",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.nextPlot && $setup.nextPlot(...args)), ["prevent"]))
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("p", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString($setup.descriptions[$setup.currPlot]), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString($setup.introductions[$setup.currPlot]), 1)
            ])
          ]),
          _createVNode(_component_router_link, { to: "/browse" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ]),
    false
      ? (_openBlock(), _createBlock(_component_MaskView, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_LoaderView)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}